<template>
    <div class="empty">
        <img :src="emptyInfo.iconImg" alt="">
        <div class="content" v-text="emptyInfo.message"></div>
    </div>
</template>

<script>
export default {
    props: {
        emptyInfo: {
            type: Object,
            default: () => {
                return {
                    iconImg: require('../../../assets/img/b2b/img_empty_order@2x.png'),
                    message: '还没有相关的订单呢'
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .empty{
        width: 300px;
        margin: 200px auto;
        text-align: center;
        img {
            width: 176px;
            height: 176px;
        }
        .content{
            color: #666666;
        }
    }
</style>